export default __webpack_public_path__ + "locales/de/PrivacyPage.json?hash=37e24b972bce6a334047a27efbbec509";